class Analytics{
    constructor(code) {

        this.GA_CODE = "UA-67887811-1";
        //*************************************************************************************************************
        this.GA_CATEGORY_LOGIN = "LOGIN";

        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_OK = "LOGIN_OK"; // IA: emial
        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_FAIL = "LOGIN_FAIL"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_FACEBOOK = "LOGIN_FACEBOOK"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_GOOGLE = "LOGIN_GOOGLE"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_LINKEDIN = "LOGIN_LINKEDIN"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_LOGIN_TUDLE = "LOGIN_TUDLE"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_LOGOUT = "LOGOUT"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_REGISTRY_SUCCESS = "REGISTRY_SUCCESS"; // IA: email
        this.GA_CATEGORY_LOGIN_EVENT_REGISTRY_FAIL = "REGISTRY_FAIL"; // IA:
        this.GA_CATEGORY_LOGIN_EVENT_REMEMBER_PASSWORD = "REMEMBER_PASSWORD"; // IA: correo introducido
        this.GA_CATEGORY_LOGIN_EVENT_GET_WORLD_TOKEN = "GET_WORLD_TOKEN"; // IA: correo introducido

        //*************************************************************************************************************

        this.GA_CATEGORY_MENU_ACCESS = "MENU_ACCESS";

        this.GA_CATEGORY_MENU_ACCESS_EVENT_GENERAL = "GENERAL";
        this.GA_CATEGORY_MENU_ACCESS_EVENT_INFO_CHALLENGES = "INFO_CHALLENGES";
        this.GA_CATEGORY_MENU_ACCESS_EVENT_RANKING = "RANKING";
        this.GA_CATEGORY_MENU_ACCESS_EVENT_FRIENDS = "FRIENDS";

        this.GA_CATEGORY_MENU_ACCESS_EVENT_WIKIQUIZ = "WIKIQUIZ";
        this.GA_CATEGORY_MENU_ACCESS_EVENT_DOCUMENTATION = "DOCUMENTATION";
        this.GA_CATEGORY_MENU_ACCESS_EVENT_CHAT = "CHAT";

        //*************************************************************************************************************
        this.GA_CATEGORY_PROFILE = "PROFILE";

        this.GA_CATEGORY_PROFILE_EVENT_ACCESS = "ACCESS"; // IA: FRIENDS o MENU dependindo desde donde se accede
        this.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE = "UPDATE_PROFILE"; // IA: SUCCESS O ERROR

        //*************************************************************************************************************

        this.GA_CATEGORY_PLAY = "PLAY";

        this.GA_CATEGORY_PLAY_EVENT_PLAY = "PLAY"; // IA: OID usuario
        this.GA_CATEGORY_PLAY_EVENT_CHALLENGE = "CHALLENGE"; // IA: current user oid
        this.GA_CATEGORY_PLAY_EVENT_NEW_PLAY = "NEW_PLAY"; // IA: current user oid
        this.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE = "NEW_CHALLENGE"; // IA: current user oid
        this.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE_FROM_FRIENDS = "NEW_CHALLENGE_FROM_FRIENDS"; // IA: SEARCHER o MENU dependiendo desde donde se lance
        this.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE_FROM_RANKING = "NEW_CHALLENGE_FROM_RANKING"; // IA: DETAIL_LIST siempre
        this.GA_CATEGORY_PLAY_EVENT_ACCEPT_CHALLENGE = "ACCEPT_CHALLENGE"; // IA: LIST_OF_CHALLENGES o DIALOG dependiendo desde donde se acepte el reto
        this.GA_CATEGORY_PLAY_EVENT_REMATCH = "REMATCH"; // IA: LIST_OF_CHALLENGES o DIALOG dependiendo desde donde se realice la revancha

        //*************************************************************************************************************
        this.GA_CATEGORY_FRIENDS = "FRIENDS";

        this.GA_CATEGORY_FRIENDS_EVENT_FACEBOOK = "FACEBOOK";  // IA: current user oid
        //this.GA_CATEGORY_FRIENDS_EVENT_CONTACTS = "CONTACTS";  // IA: current user oid
        this.GA_CATEGORY_FRIENDS_EVENT_HIQUIZ = "HIQUIZ";  // IA: current user oid
        this.GA_CATEGORY_FRIENDS_EVENT_CONNECT_FACEBOOK = "CONNECT_FACEBOOK"; // IA: current user oid
        this.GA_CATEGORY_FRIENDS_EVENT_CONNECT_FACEBOOK_SUCCESS = "CONNECT_FACEBOOK_SUCCESS";  // IA: current user oid
        this.GA_CATEGORY_FRIENDS_EVENT_CONNECT_FACEBOOK_FAIL = "CONNECT_FACEBOOK_FAIL"; // IA: current user oid

    //*************************************************************************************************************
        this.GA_CATEGORY_WIKIQUIZ = "WIKIQUIZ";

        this.GA_CATEGORY_WIKIQUIZ_EVENT_ADD_QUESTION = "ADD_QUESTION"; // IA: current user oid
        this.GA_CATEGORY_WIKIQUIZ_EVENT_RIGHT_QUESTION = "RIGHT_QUESTION"; // IA: current user oid

        //*************************************************************************************************************
        this.GA_CATEGORY_RANKING = "RANKING";

        this.GA_CATEGORY_RANKING_EVENT_GO_TO_RANKING_GROUP = "GO_TO_RANKING_GROUP"; // T�tulo del ranquing espec�fico
        //this.GA_CATEGORY_RANKING_EVENT_RANKING_TAB_SELECTED = "RANKING_TAB_SELECTED";

    //*************************************************************************************************************

        this.GA_CATEGORY_DOCUMENTATION = "DOCUMENTATION";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_ACCESS_DOCUMENT = "ACCESS_DOCUMENT";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_FAVOURITE = "MAKE_FAVOURITE";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_SHARE = "SHARE";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_STOP_SHARING = "STOP_SHARING";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_RATE_DOCUMENT = "RATE_DOCUMENT";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_COMMENT = "MAKE_COMMENT";
        this.GA_CATEGORY_DOCUMENTATION_EVENT_UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT";

    //*************************************************************************************************************

        //this.GA_SCREEN_SPLASH = "SPLASH";
        //this.GA_SCREEN_LOGIN_WORLD = "LOGIN_WORLD";-->Esta no puede tener analiticas
        this.GA_SCREEN_LOGIN = "LOGIN";
        this.GA_SCREEN_MENU = "MENU";
        this.GA_SCREEN_SELECT_CATEGORY = "SELECT_CATEGORY";
        this.GA_SCREEN_PROFILE = "PROFILE";
        this.GA_SCREEN_WELCOME = "WELCOME";
        this.GA_SCREEN_INDIVIDUAL_GAME = "INDIVIDUAL_GAME";
        this.GA_SCREEN_SELECT_FRIEND = "SELECT_FRIEND";
        this.GA_SCREEN_SELECT_POINTS = "SELECT_POINTS";
        this.GA_SCREEN_CHALLENGES_GAME = "CHALLENGES_GAME";
        this.GA_SCREEN_RANKING_DETAIL = "RANKING_DETAIL";
        this.GA_SCREEN_RANKING_DETAIL_GROUP = "RANKING_DETAIL_GROUP";
        this.GA_SCREEN_EDIT_PROFILE = "EDIT_PROFILE";

        this.GA_SCREEN_SELECT_CATEGORIES_WIKIQUIZ = "SELECT_CATEGORIES_WIKIQUIZ";
        this.GA_SCREEN_ADD_QUESTION = "ADD_QUESTION";
        this.GA_SCREEN_RIGHT_QUESTION = "RIGHT_QUESTION";

        this.GA_SCREEN_REGISTRY = "REGISTRY";
        this.GA_SCREEN_FRIENDS = "FRIENDS";
        this.GA_SCREEN_CONNECT_FACEBOOK = "CONNECT_FACEBOOK";
        this.GA_SCREEN_LEVELS = "LEVELS";
        this.GA_SCREEN_SHOW_DOCUMENT_FILE = "SHOW_DOCUMENT_FILE";


        //*************************************************************************************************************

        this.GA_DIMENSION_WORLD = 1;
        this.GA_DIMENSION_USER = 2;

        //*************************************************************************************************************

        if(!code){

            code = this.GA_CODE;

        }
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
            ga('create',code , 'auto');
            ga('set', 'dimension'+ this.GA_DIMENSION_WORLD, world.token);

    }
}